// 탭 간 이동 + 포커스 요청용 초경량 pub/sub
// (멀티탭 구조라 컴포넌트가 항상 마운트되어 있음 — TabLayout이 탭 전환을, 대상 페이지가 포커스 처리를 각각 구독)
const listeners = new Set();

export const subscribeTabNav = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const emitTabNav = (event) => {
  listeners.forEach((fn) => fn(event));
};

// 건별수익률현황 메모 클릭 → 매수등록 화면으로 이동, 해당 매수건 선택
export const goToBuyRecord = (buyId) => {
  emitTabNav({ tab: 'buy', buyId });
};

// 건별수익률현황 매도금액 클릭 → 매도등록 화면으로 이동, 해당 매도건 선택
export const goToSellRecord = (sellId) => {
  emitTabNav({ tab: 'sell', sellId });
};
